// ContainerHomeStyles.js
import styled from "styled-components";

export const Wrapper = styled.div`
  .ContainerHome {
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-wrap: wrap;
  }

  .InfoBlock {
    flex: 1;
    background-color: ${({ theme }) => theme.cardTransparent};
    border-radius: 12px;
    border: 0.1px solid rgba(255, 255, 255, 0.3);
    padding: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: auto;
  }

  .SubtitleHome {
    font-size: 18px;
    color: ${({ theme }) => theme.text};
    font-weight: 550;
    margin-bottom: 10px;
    word-spacing: 2px;
    line-height: 22px;
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
  }

  .DescriptionHome {
    font-size: 18px;
    word-spacing: 2px;
    line-height: 20px;
    color: ${({ theme }) => theme.text};
    font-family: "Roboto", "Montserrat", "Instruments-sans", sans-serif;
  }

  .IconHome {
    width: 48px;
    height: 48px;
    background-color: ${({ theme }) => theme.iconPadd};
    transition: background-color 0.3s ease-in;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin-bottom: 15px;
  }

  .IconHome img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    display: block;
    background-color: transparent;
  }

  .IconHome svg {
    font-size: 18px;
  }

  @media screen and (max-width: 1024px) {
    .ContainerHome {
      flex-direction: column;
      align-items: center;
      gap: 20px;
    }

    .InfoBlock {
      max-width: 350px;
      min-height: auto;
      padding: 20px;
    }

    .SubtitleHome {
      font-size: 18px;
      text-align: left;
      max-width: 300px;
    }

    .DescriptionHome {
      font-size: 14px;
      text-align: left;
      max-width: 350px;
      align-items: center;
    }

    .IconHome svg {
      font-size: 25px;
    }
  }
`;
